import moment from 'moment';

const DefaultObsolescenceTimeout = 10; // minutes

export const isDataObsolete = (timestampMark: number | null, timeoutMinutes = DefaultObsolescenceTimeout): boolean => {
  return timestampMark != null && moment().diff(moment(timestampMark), 'minutes') >= timeoutMinutes;
};
